
function SearchFilters(){
	$('.search-list-filters a').click(function(){
		var $this 	 = $(this);
		var $type  	 = $this.data('type');
		var $partial = $('.partial.search-results');

		$('.search-list-filters a').removeClass('active');
		$this.addClass('active');
		
		$partial.data('type',$type)		
		$partial.data('page','1');		
		load_partial($partial);
		return false;	
	});	 
}

